import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DialogButtons } from '../dialogs.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'smart-confirm-dialog',
  template: `
    <div class="modal-header">
      <div class="modal-title" [innerHTML]="title">
      </div>
      <button *ngIf="buttons.close" type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close($event)">
         <span aria-hidden="true"><i class="fal fa-times"></i></span>
      </button>
    </div>
    <div class="modal-body" [innerHTML]="message"></div>
    <div class="modal-footer" *ngIf="buttons">
      <button (click)="confirm($event)" type="button" class="btn bootbox-accept {{buttons.confirm.className}}">
      {{buttons.confirm.label}}</button>
      <button (click)="no($event)" type="button" class="btn bootbox-cancel {{buttons.no.className}}" *ngIf="buttons.no">
      {{buttons.no.label}}</button>        
      <button (click)="cancel($event)" type="button" class="btn bootbox-cancel {{buttons.cancel.className}}">
      {{buttons.cancel.label}}</button>    
    </div>
  `,
})
export class ConfirmDialogComponent {
  title: string;
  message: string;
  buttons: DialogButtons;
  onClose = new Subject();

  constructor(public bsModalRef: BsModalRef) { }

  confirm($event: MouseEvent) {
    this.onClose.next(true);
    this.onClose.complete();
    this.bsModalRef.hide();
  }
  cancel($event: MouseEvent) {
    this.onClose.next(false);
    this.onClose.complete();
    this.bsModalRef.hide();
  }
  no($event: MouseEvent) {
    this.onClose.next("no");
    this.onClose.complete();
    this.bsModalRef.hide();
  }
  close($event: MouseEvent) {
    this.bsModalRef.hide();
  }  
}
